module.exports = __webpack_public_path__ + "static/media/file-icon.74da0aa9.svg";